
import React, { useState } from 'react';

interface PlaceModalPhotosTabProps {
  photoUrls: string[];
}

const PlaceModalPhotosTab: React.FC<PlaceModalPhotosTabProps> = ({ photoUrls }) => {
  const [failedUrls, setFailedUrls] = useState<Set<string>>(new Set());

  const visible = photoUrls.filter((url) => !failedUrls.has(url));

  const handleError = (url: string) => {
    setFailedUrls((prev) => new Set([...prev, url]));
  };

  if (visible.length === 0) {
    return (
      <div
        role="tabpanel"
        id="place-modal-panel-photos"
        aria-labelledby="place-modal-tab-photos"
        className="flex flex-col items-center justify-center px-0 py-16 text-center"
      >
        <p className="text-sm text-gray-500">No photos available for this place yet.</p>
      </div>
    );
  }

  return (
    <div
      role="tabpanel"
      id="place-modal-panel-photos"
      aria-labelledby="place-modal-tab-photos"
      className="grid grid-cols-3 gap-2 px-0 pb-6 pt-0 sm:grid-cols-3"
    >
      {visible.map((url, i) => (
        <div key={url} className="relative aspect-square rounded-xl overflow-hidden bg-gray-100">
          <img
            src={url}
            alt={`Place photo ${i + 1}`}
            className="w-full h-full object-cover"
            loading="lazy"
            onError={() => handleError(url)}
          />
        </div>
      ))}
    </div>
  );
};

export default PlaceModalPhotosTab;
